import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { SENFULLY_APP_URL } from "../appConfig";
import logo from "../assets/brand/senfully-logo-horizontal-color.svg";
import { Icon } from "./Icon";
import "./styles/SiteHeader.css";

interface NavLinkItem {
  to: string;
  label: string;
  /** Match only this exact address, so Home isn't lit up on every page. */
  isExact?: boolean;
}

export const NAV_LINKS: NavLinkItem[] = [
  { to: "/", label: "Home", isExact: true },
  { to: "/features", label: "Features" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMenuOpen) return;
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") setIsMenuOpen(false);
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isMenuOpen]);

  function handleMenuClose() {
    setIsMenuOpen(false);
  }

  function handleMenuToggle() {
    setIsMenuOpen((isOpen) => !isOpen);
  }

  return (
    <header className="site-header">
      <div className="container site-header__bar">
        <Link to="/" className="site-header__brand" aria-label="SENfully home">
          <img src={logo} alt="SENfully" width={147} height={36} />
        </Link>

        <nav className="site-header__nav" aria-label="Main">
          {NAV_LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} end={link.isExact} className="site-header__link">{link.label}</NavLink>
          ))}
        </nav>

        <div className="site-header__actions">
          <a href={SENFULLY_APP_URL} className="btn btn--ghost btn--sm site-header__login">Log in</a>
          <Link to="/get-senfully" className="btn btn--primary btn--sm">Get SENfully</Link>
          <button
            type="button"
            className="site-header__menu-button"
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
            aria-controls="site-menu"
            onClick={handleMenuToggle}
          >
            <Icon name={isMenuOpen ? "close" : "menu"} />
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <>
          <button type="button" className="site-header__scrim" aria-label="Close menu" tabIndex={-1} onClick={handleMenuClose} />
          <nav id="site-menu" className="site-header__menu" aria-label="Menu">
            <div className="container site-header__menu-inner">
              {NAV_LINKS.map((link) => (
                <NavLink key={link.to} to={link.to} end={link.isExact} className="site-header__menu-link">{link.label}</NavLink>
              ))}
              <a href={SENFULLY_APP_URL} className="btn btn--ghost site-header__menu-login">Log in</a>
            </div>
          </nav>
        </>
      )}
    </header>
  );
}
